var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-grid-table',{staticClass:"border-bottom border-primary font-weight-bolder mb-1",attrs:{"list":_vm.list,"col-count":_vm.colCount,"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }